import { useEffect, useRef } from 'react';
function Modal({ open, onClose, title, subtitle, variant = 'default', titleHidden = false, children }) {
  const ref = useRef(null);
  useEffect(() => {
    const d = ref.current;
    if (!d) return;
    if (open && !d.open) {
      d.showModal();
      d.scrollTop = 0;
    } else if (!open && d.open) {
      d.close();
    }
  }, [open]);
  useEffect(() => {
    if (!open) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  }, [open]);
  return (
    <dialog
      ref={ref}
      className={['tcf-modal', variant === 'video' ? 'tcf-modal--video' : ''].join(' ').trim()}
      aria-labelledby="tcf-modal-title"
      onClose={onClose}
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div className="tcf-modal-panel">
        <button type="button" className="tcf-modal-close" onClick={onClose} aria-label="Close">
          <svg width="18" height="18" viewBox="0 0 16 16" fill="none" aria-hidden="true">
            <path d="M3 3l10 10M13 3L3 13" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
          </svg>
        </button>
        {variant === 'video' || titleHidden ? (
          <h2 className="tcf-visually-hidden" id="tcf-modal-title">
            {title}
          </h2>
        ) : (
          <div className="tcf-modal-header">
            <h2 className="tcf-modal-title" id="tcf-modal-title">
              {title}
            </h2>
            {subtitle && <p className="tcf-modal-subtitle">{subtitle}</p>}
          </div>
        )}
        <div className="tcf-modal-body">{children}</div>
      </div>
    </dialog>
  );
}
export { Modal };
